import { IRequireSubType } from '../interfaces/IRequireSubType';
import { IBaseCDV3ViewItem } from '../interfaces/ICDViewItem';
import { eSubtypes } from '../../enums/eSubTypes';

type IPresentationItemWithSubType = Partial<IBaseCDV3ViewItem> & Partial<IRequireSubType<eSubtypes>>;

const forItem = (item: IPresentationItemWithSubType) => (entry: IPresentationItemWithSubType) =>
  item.type === entry.type && item.sub_type === entry.sub_type;

export const sortByTypeAndSubType = (order: IPresentationItemWithSubType[]) => {
  return (item1: IPresentationItemWithSubType, item2: IPresentationItemWithSubType) => {
    const position1 = order.findIndex(forItem(item1));
    const position2 = order.findIndex(forItem(item2));
    return position1 - position2;
  };
};
